import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { UserContext } from "../UserContext";

const Transactions = () => {
  const [user] = useContext(UserContext);
  const [transactions, setTransactions] = useState([]);
  const history = useHistory();
  useEffect(() => {
    if (user.role === "unauthenticated") {
      history.push("/");
    } else {
      const abc = async () => {
        const Transactions = await axios.post(
          "https://salt-neobank.herokuapp.com/user/transactions",
          {
            acc_no: user.acc_no,
          }
        );
        Transactions.data[0] &&
          setTransactions(Transactions.data[0].transactions);
      };
      abc();
    }
  }, [history, user.acc_no, user.role]);
  return (
    <Container>
      <Section>
        <table>
          <tbody>
            <tr>
              <th>Date</th>
              <th>Credit</th>
              <th>Debit</th>
              <th>Balance</th>
            </tr>
            {transactions.map((e) => {
              return (
                <tr key={e.date}>
                  <td>{new Date(e.date).toLocaleDateString()}</td>
                  <td>{e.credit}</td>
                  <td>{e.debit}</td>
                  <td>{e.bal}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Section>
    </Container>
  );
};
const Container = styled.div``;
const Section = styled.div`
  display: flex;
  td {
    padding: 0.5em;
    max-width: 300px;
    background: #ddd;
  }
  th {
    padding: 0.5em;
    background-color: #f5642f;
    color: white;
  }
`;
export default Transactions;
